import { isHslUser, isSuperuser, type UserShape } from 'Services/common/Features/User/userSlice'
import {
  GLOBAL_SECTION_PATHS,
  SALES_MANAGEMENT_ROOT_URL,
  SELECTED_PTA_STORAGE_KEY
} from 'Util/constants'
import type { Location } from 'react-router-dom'

const getSelectedPta = () => {
  return localStorage.getItem(SELECTED_PTA_STORAGE_KEY) ?? ''
}

const isPtaSelectionVisible = (user: UserShape | null, location: Location) => {
  // Check if url path contains sales-management
  const isSalesManagement = location.pathname.includes(SALES_MANAGEMENT_ROOT_URL)

  /**
   * User is not HSL user and is superuser
   * and current path is not sales-management
   */
  const isNotHslUser = !isHslUser(user)
  const isSuperUser = isSuperuser(user)
  const isNotSalesManagement = !isSalesManagement
  return isNotHslUser && isSuperUser && isNotSalesManagement
}

const isGlobalSection = (location: Location) => {
  return GLOBAL_SECTION_PATHS.some(path => location.pathname.includes(path))
}

const isPtaBannerVisible = (user: UserShape | null, location: Location) => {
  return (
    isPtaSelectionVisible(user, location) && (getSelectedPta() !== '' || isGlobalSection(location))
  )
}

export { getSelectedPta, isGlobalSection, isPtaBannerVisible, isPtaSelectionVisible }
